import type { ReactNode } from "react";
import { UserMenu } from "@/components/auth/UserMenu";
import { AppHeader } from "@/components/layout/AppHeader";

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppHeader>
        <UserMenu />
      </AppHeader>
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
